export const convertBookInfo = (metadata: any, bookId: string) => {
  if (!metadata || !Array.isArray(metadata.Values)) {
    console.error("Invalid metadata provided.");
    return false;
  }

  const authorsInfos = [];
  let currentAuthor: { [key: string]: any } = {};
  let authorsCount = 0;
  const newBookInfo = metadata.Values.reduce((acc: any, element: any) => {
    if (element.Name) {
      if (isNotAuthorInfo(element.Name)) {
        acc[element.Name] = element.Value;
      } else {
        if (element.Name === "AuthorName") {
          if (authorsCount > 0) authorsInfos.push(currentAuthor);
          authorsCount++;
          currentAuthor = { Name: element.Value }; // Initialize a new author object;
        } else {
          let value = element.Value;
          if (element.Name === "AuthorDescription" && value) {
            value = value.replace(/<\/?br\s*\/?>/gi, ""); // Remove line breaks from author description
          }

          currentAuthor[element.Name.replace(/^Author/, "")] = value;
        }
      }

      return acc;
    }
  }, {});

  authorsInfos.push(currentAuthor); // Push the last author object

  // Parse external authors (Author_1/AuthorLink_1, Author_2/AuthorLink_2, ...)
  if (newBookInfo.IsExternalAuthors === "true") {
    let i = 1;
    while (newBookInfo[`Author_${i}`]) {
      authorsInfos.push({
        Name: newBookInfo[`Author_${i}`],
        ExternalUrl: newBookInfo[`AuthorLink_${i}`] || null,
      });
      delete newBookInfo[`Author_${i}`];
      delete newBookInfo[`AuthorLink_${i}`];
      i++;
    }
  }

  newBookInfo["AuthorsInfos"] = authorsInfos;

  newBookInfo["BookId"] = bookId;
  return newBookInfo;
};

export const changePageTitle = (bookTitle: string) => {
  document.title = bookTitle + " - Karnov Bøker";
};

export const refineBookId = (bookIdQuery: string) => {
  // return last part of the bookId
  return bookIdQuery.split("/").pop();
};

const isNotAuthorInfo = (name: string) => {
  return name !== "AuthorName" && name !== "AuthorTitle" && name !== "AuthorDescription" && name !== "AuthorImageUrl";
};
